import { REALISM, type AircraftState, type AirportData } from '@atc/core';
import { createRadarScope } from '@atc/radar';
import type { DebriefEvent } from '@atc/sim';

export function mountShiftReplay(root: HTMLElement, airport: AirportData, frames: { timeS: number; aircraft: AircraftState[] }[], events: readonly DebriefEvent[], practice?: (timeS: number) => void) {
  if (!frames.length) return () => {};
  root.innerHTML = '<h3>Review the shift</h3><div class="shift-replay-scope"></div><label>Replay time <input type="range" min="0" step="1" aria-label="Replay time"></label><p class="shift-replay-event"></p><button class="btn" type="button">Practice before this moment</button><p class="debrief-note">Recorded positions every five seconds. Practice resumes from the preceding 30-second checkpoint with local pilots and is not ranked.</p>';
  const scope = createRadarScope(root.querySelector<HTMLElement>('.shift-replay-scope')!, airport, { realism: REALISM.low });
  const slider = root.querySelector<HTMLInputElement>('input')!;
  const text = root.querySelector<HTMLElement>('.shift-replay-event')!;
  const button = root.querySelector<HTMLButtonElement>('button')!;
  slider.max = String(frames.length - 1); slider.value = String(frames.length - 1);
  button.hidden = !practice;
  const render = () => {
    const frame = frames[Number(slider.value)]!;
    scope.update(frame.aircraft, frame.timeS);
    const event = events.filter((e) => e.timeS <= frame.timeS).at(-1);
    text.textContent = `${Math.floor(frame.timeS / 60)}:${String(Math.floor(frame.timeS % 60)).padStart(2, '0')}${event ? ` — ${event.callsigns.join(', ')}: ${event.detail}` : ' — No recorded incident yet.'}`;
  };
  slider.oninput = render;
  button.onclick = () => practice?.(Math.max(0, frames[Number(slider.value)]!.timeS - 30));
  render();
  return () => scope.destroy();
}
